module.exports = __webpack_public_path__ + "static/media/M1-4-Nayromi-Naybul-cod103.c15d978f.png";